<template>
    <el-dialog :title="$t('advertPaper')"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               @close="dialogClose"
               center
               top="5vh"
               custom-class="large-dialog">
        <div
            class="content"
            v-loading="loading"
            :element-loading-text="$t('uploadLoadingHint')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <div class="list">
                <draggable v-model="fileList">
                    <transition-group>
                        <div class="list-item" v-for="(item, index) in fileList" :key="item.url">
                            <div class="avatar-uploader">
                                <img :src="item.url + '_-200.png'" class="avatar">
                                <div class="avatar-icon">
                                    <i class="el-icon-delete" @click.stop="handleRemoveImage(index)"></i>
                                </div>
                            </div>
                        </div>
                    </transition-group>
                </draggable>
                <div class="list-item">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        multiple
                        action=""
                        :file-list="fileList"
                        :http-request="imageHttpRequest"
                        accept="image/jpg,image/jpeg,image/png,image/gif">
                        <div class="avatar-icon">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </div>
                    </el-upload>
                </div>
                <div class="list-item">
                    <el-upload
                        class="avatar-uploader"
                        :show-file-list="false"
                        :multiple="false"
                        action=""
                        :file-list="fileList"
                        :http-request="pdfHttpRequest"
                        accept=".pdf">
                        <div class="avatar-icon">
                            <i class="el-icon-plus avatar-uploader-icon">PDF</i>
                        </div>
                    </el-upload>
                </div>
            </div>
        </div>
        <div slot="footer"
             class="dialog-footer">
            <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"
                       size="mini"
                       :disabled="disabled"
                       @click="confirmHandle">{{ $t('confirm') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
import {queryAdvertContainer, updateAdvertContainer, uploadImage, uploadPdf} from "@/api/modules/api";
import draggable from 'vuedraggable'
export default {
    name: 'Paper',
    components: {
        draggable
    },
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    data () {
        return {
            dialogVisible: false,
            loading: false,
            fileList: [],
            disabled: false,
        }
    },
    created () { },
    mounted () { },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.fileList = []
            // 获取广告列表
            this.getPaperList()
        },
    
        // 获取广告列表
        getPaperList () {
            const params = {
                showcaseId: this.parentId
            }
            queryAdvertContainer(params).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data || []
                    this.fileList = resData.map(item => {
                        return {
                            id: item.id,
                            url: item.image
                        }
                    })
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        
        /******** 图片 ********/
        // 上传图片
        imageHttpRequest(val) {
            let formData = new FormData();
            formData.append("file", val.file);
            uploadImage(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        let url = res.data.url;
                        if (url) {
                            this.fileList.push({
                                id: '',
                                url
                            })
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err);
                })
        },
        // 上传PDF
        pdfHttpRequest (val) {
            let formData = new FormData();
            formData.append("file", val.file);
            this.loading = true
            uploadPdf(formData)
                .then(res => {
                    if (Number(res.code) === 20000) {
                        let imgUrls = res.data.imgUrls
                        if (imgUrls instanceof Array) {
                            let urls = imgUrls.map(item => {
                                return {
                                    id: '',
                                    url: item
                                }
                            })
                            this.fileList = [...this.fileList, ...urls]
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                this.$message.error(err);
            }).finally(() => {
                this.loading = false;
            })
        },
        // 删除图片
        handleRemoveImage (index) {
            this.fileList.splice(index, 1)
        },
        
        // 提交
        confirmHandle () {
            let items = this.fileList.map((item, index) => {
                return {
                    id: item.id,
                    image: item.url,
                    sort: index
                }
            })
            const params = {
                showcaseId: this.parentId,
                items
            }
            this.disabled = true;
            updateAdvertContainer(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
.content{
    width: 100%;
    max-height: 620px;
    overflow-y: auto;
    .list{
        width: 100%;
        .list-item{
            vertical-align: top;
            display: inline-block;
            margin: 5px;
            .avatar-uploader{
                width: 168px;
                height: 168px;
                display: flex;
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
                &:hover {
                    border-color: #409EFF;
                }
                img{
                    width: 100%;
                    height: 100%;
                }
                .avatar-icon{
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    i{
                        font-size: 28px;
                    }
                    .el-icon-delete{
                        color: red;
                        display: none;
                    }
                    &:hover{
                        background-color: rgba(0, 0, 0, .3);
                        .el-icon-delete{
                            display: inline-block;
                        }
                    }
                }
            }
        }
    }
}
</style>
